import { render } from "./Cases.vue?vue&type=template&id=8bf747a2&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=ts"
export * from "./Cases.vue?vue&type=script&lang=ts"

import "./Cases.vue?vue&type=style&index=0&id=8bf747a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8bf747a2"

export default script